import React from "react";
import { Badge } from "../components/ui/badge";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "../components/ui/breadcrumb";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asKnowledgeRecord, listResults } from "../lib/thirdDoorAdapters";

export default function ResourcesGuides() {
  const { resources } = useModelIndex("knowledge_record" as any, { limit: 12 } as any);
  const guides = listResults(resources).map(asKnowledgeRecord);
  return (
    <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <Breadcrumb>
      <BreadcrumbList>
      <BreadcrumbItem><BreadcrumbLink asChild><Link to="/resources">Resources</Link></BreadcrumbLink></BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem><BreadcrumbPage>Guides</BreadcrumbPage></BreadcrumbItem>
      </BreadcrumbList>
      </Breadcrumb>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {guides.map((guide) => (
      <Card key={guide.title}>
      <CardHeader><Badge variant="secondary" className="w-fit">Guide</Badge><CardTitle>{guide.title}</CardTitle><CardDescription>{guide.description}</CardDescription></CardHeader>
      <CardContent><Button asChild variant="outline"><Link to={guide.href}>Open guide</Link></Button></CardContent>
      </Card>
      ))}
      </div>
      </section>
      </div>
    </div>
  );
}